import { Link, NavLink, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { LogOut, Settings, ShoppingBag } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import CartPopover from "./CartPopover";

export default function Header() {
  const { isAdmin, logout } = useAuth();
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const leave = () => { logout(); navigate("/login"); };

  return (
    <header className="app-header" data-testid="main-header">
      <Link to="/produkte" className="brand logo-brand" data-testid="header-brand-link"><img src="https://customer-assets.emergentagent.com/job_blueprint-store-3/artifacts/vblfk2l1_DOSA-Shop_Logo.png" alt="DOSA Shop" data-testid="header-logo-image" /></Link>
      <nav className="nav-links" data-testid="header-navigation">
        <NavLink to="/produkte" data-testid="header-products-link">Shop</NavLink>
        {!isAdmin && <NavLink to="/meine-anfragen" data-testid="header-my-orders-link">Meine Anfragen</NavLink>}
        <NavLink to="/account" data-testid="header-account-link">Account</NavLink>
        {isAdmin && <NavLink to="/admin/anfragen" data-testid="header-admin-requests-link">Anfragen</NavLink>}
        {isAdmin && <NavLink to="/admin" data-testid="header-admin-link"><Settings size={16} /> Admin</NavLink>}
      </nav>
      <div className="header-actions">
        {!isAdmin && <div className="cart-wrap">
          <button className="icon-button" onClick={() => setOpen(!open)} data-testid="header-cart-icon" aria-label="Warenkorb">
            <ShoppingBag size={21} /><span data-testid="header-cart-count">{count}</span>
          </button>
          {open && <CartPopover onClose={() => setOpen(false)} />}
        </div>}
        <button className="icon-button" onClick={leave} data-testid="header-logout-button" aria-label="Logout"><LogOut size={20} /></button>
      </div>
    </header>
  );
}